import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./BackToTop.module.sass";
import Icon from "../Icon";

const BackToTop = ({ className }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <button
      className={cn(styles.backToTop, className)}
      onClick={scrollToTop}
      aria-label="Retour en haut de la page"
    >
      <Icon name="arrow-right" size="16" />
    </button>
  );
};

export default BackToTop;
